import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { md5 } from './../Global/md5';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { PerfilModel } from './Perfil.model';




import { OpcionModel } from '../Global/Opcion.model';


@Component({
	selector : 'crearPerfil',
	templateUrl : './CrearPerfilIndex.component.html',
	styleUrls  : ['../../../../styles.css']
})


export class CrearPerfilIndexComponent {
	
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	filteredOptions: Observable<PerfilModel[]>;
	
	
	public ocultar: boolean = false;
	public mensaje: string = "";

	public displayedColumns = ['Nombre Perfil', 'editar'];
	public dataDataBase:OpcionesDatabase;
	public dataSource:ExampleDataSource;

	constructor(private formBuilder: FormBuilder, private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router:Router, public dialog: MatDialog){
		
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
	}


	ngOnInit(){
		
		this.cargarTabla();


	}

	
	cargarTabla(){

		this.dataDataBase = new OpcionesDatabase();

		this._serviciosGenerales.get('consultarRoles', {ntipoempresa : -1}).subscribe(result=>{
			for(let x in result){
				this.dataDataBase.addOpcion(new PerfilModel(result[x].nidrol, result[x].cdescriprol));
			}
			this.dataSource = new ExampleDataSource(this.dataDataBase);
		},error=>{
			console.log(error, '');
			this.openSnackBarEspecial("Ocurrió un error al momento de consultar las opciones disponibles", "X");
		});
		
	}


	editarRegistro(perfil:PerfilModel){
		this._router.navigate(['/CrearPerfil',perfil.nidrol, perfil.cdescriprol]);
	}

	agregar(){
		this._router.navigate(['/CrearPerfil']);	
	}


	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});

	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}


}



// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class OpcionesDatabase
{
	
	dataChange: BehaviorSubject<PerfilModel[]> = new BehaviorSubject<PerfilModel[]>([]);

	get data(): PerfilModel[]
	{
		return this.dataChange.value;
	}

	addOpcion(opcion:PerfilModel)
	{
		const copiedData = this.data.slice();
		copiedData.push(opcion);
		this.dataChange.next(copiedData);
	}

}


export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string
	{
		return this._filterChange.value;
	}

	set filter(filter: string)
	{
		console.log(filter);
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: OpcionesDatabase)
	{
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<PerfilModel[]>
	{
		const displayDataChanges = [
		this._exampleDatabase.dataChange,
		this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: PerfilModel) => {
				let searchStr = (item.cdescriprol).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect()
	{
	}
}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/AdministracionUsuarios/CrearPerfilIndex.component.ts